export default ({ theme }) => {
  return `
    .landing-banner-container {
      position: relative;
    }
  `;
}
